import { ApiModel, ApiModelOptions } from "../../../ApiModel";
import { FlattenedInvestmentModel } from "../../../models";

export function apiFlattenedInvestmentModel(
  opts: ApiModelOptions<FlattenedInvestmentModel>,
) {
  return ApiModel<FlattenedInvestmentModel>("flattened-investment", opts);
}
